/*
 * This file is part of sepia-themes.
 * Copyright (C) 2024 Data Futures GmbH.
 *
 * sepia-themes is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

import React from "react";

/**
 * Factory function to render component
 * @param componentsAvailable {string[]} Components available in the current module.
 * @returns {Promise<void>} Componentes are rendered in DOM.
 */
const renderFactory = async (componentsAvailable) => {
  await componentsAvailable.forEach(async (componentName) => {
    const componentModule = await import(`./${componentName}`);
    componentModule.renderComponent();
  });
};

// Importing the components
const componentsAvailable = ["searchbox"];

renderFactory(componentsAvailable);
